import React, { useRef } from 'react';
import { Button, Modal } from 'antd';
import { useReactToPrint } from 'react-to-print';

import TM31 from './TM31';
import { IOrder } from '@/interfaces/order';
import { IBillingNote } from '@/interfaces/billing-note';

interface IProps {
  open: boolean;
  handleCancel: () => void;
  billingNote: Partial<IBillingNote>;
  order?: Partial<IOrder>;
}

const PrintBillingNoteModal = ({
  open,
  handleCancel,
  billingNote,
  order,
}: IProps) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `${billingNote?.code}`,
  });

  return (
    <Modal
      title="พิมพ์เอกสาร"
      open={open}
      width={'1100px'}
      onOk={() => handleCancel}
      onCancel={handleCancel}
      okText="บันทึก"
      cancelText="ยกเลิก"
      footer={[
        <Button key="back" onClick={handleCancel}>
          ปิด
        </Button>,
        <Button type="primary" key="print" onClick={() => handlePrint()}>
          พิมพ์เอกสาร
        </Button>,
      ]}
    >
      <div className="flex flex-col overflow-y-auto bg-gray-200 p-2 max-h-[600px] font-ibm gap-5">
        <div ref={contentRef} className="flex flex-col">
          <TM31
            data={(order as IOrder) || []}
            billingNote={billingNote as IBillingNote}
          />
        </div>
      </div>
    </Modal>
  );
};

export default PrintBillingNoteModal;
